import http from "infra/http";
import { useQuery } from "react-query";
import { IndexadorDetalhe } from "../typings";

function useGetIndexador(id?: string) {
  return useQuery([`/v1/indexador/:id`], async () => {
    const { data } = await http.get(`/v1/indexador/${id}`);
    return data as IndexadorDetalhe;
  }, {
    enabled: !!id,
  });
}

export default useGetIndexador;
